import type { ComponentStyleConfig } from "@chakra-ui/theme";

export const Checkbox: ComponentStyleConfig = {
  baseStyle: {
    label: {
      textAlign: "left",
    },
    control: {
      my: "auto",
      p: "tiny",
      bg: "brand.background.light",
      borderRadius: "6px",
      borderColor: "brand.border.light",
      border: "1px",
      _hover: {
        borderColor: "new.gray.500",
      },
      _checked: {
        borderColor: "brand.accent.primary",
        bg: "brand.accent.primary",
        color: "brand.text.light",
        _hover: {
          bg: "new.green.150",
          borderColor: "new.green.150",
        },
        _focus: {
          bg: "new.green.150",
        },
      },
    },
  },
};
